'use strict';

const registry = {};

exports.subscribe = (event, action) => {
  const handlers = registry[event];

  if (!handlers) {
    registry[event] = [];
  }

  registry[event].push(action);
};

exports.publish = (event, data) => {
  const handlers = registry[event] || [];

  handlers.forEach(action => action(data));
};
